import React, { useEffect, useState } from 'react';
import { Routes, Route, Outlet, useNavigate } from 'react-router-dom';
import './App.css';
import './Custom.css';
import { HomeContainer } from './routes/home';
import { LandingContainer } from './routes/landing';
import { AuthContext } from './shared/context/AuthContext';
import { User } from '@shared/auth/type';
import { useLocalStorage } from '@shared/auth/useLocalStorage';
import { Dashboard } from '@component/dashboard/components/dahsboard';
import Setting from '@component/setting/setting';
import Location from '@component/location/location';
import { Notification } from '@component/notification/notification';
import { Categories } from '@component/category/category';
import ManageRoles from '@component/manage_Roles/manageRoles';
// import Notification from '@component/notification/notification'
import UserManagement from '@component/userManagement/userManagement';
import { Items } from '@component/items/items';
import { Penalty } from '@component/penalty/penalty';
import { Demand_other } from '@component/demand_other/demand_other';
import { Demand_transporter } from '@component/demand_transporter/demand_transporter';
import { Bids } from '@component/bids/bids';
import ProtectedRoute from '@shared/ProtectedRoute';
import { Toaster } from 'react-hot-toast';
import { VendoRegistration } from '@component/vendorRegistration/vendorRegistration';
import { Transporter } from '@component/mobile_app/transporter';
import { OthersMobileUsers } from '@component/mobile_app/others';
import { VendoRegistrationOther } from '@component/vendorRegistrationother/vendorRegistrationother';
import { HelpSupport } from '@component/help_support/help_support';
import SignupRequest from '@component/signup_request/SignupRequest';
import { FinalisedBids } from '@component/finalisedbids/finalisedbids';
import { FinalisedBidsOthers } from '@component/finalisedbids/finalisedbidsOther';
import { VendorDelay } from '@component/vendordelay/vendordelay';
import { TransporterReport } from '@component/reports/transporterReport';
import { OtherReport } from '@component/reports/other';
import { Modal, Button } from 'react-bootstrap';
import Notify from '@shared/notify';
import PageNotFound from '@component/404';
import { ForgotContainer } from '@component/forgotpassword/forgotpassword';
import TermsCondition from '@component/termsCondition/termsCondition';
import PrivacyPolicy from '@component/PrivacyPolicy/PrivacyPolicy';

const App: React.FC = () => {
    const [userLocal, setLocalUser] = useState<User | null>(null);
    const { setItem, getItem, removeItem } = useLocalStorage();

    const navigate = useNavigate();
    useEffect(() => {
        if (getItem('user') !== null) {
            const userStr = getItem('user');
            const user = JSON.parse(userStr!);
            setLocalUser(user);
        }
    }, []);
    const addUser = (user: User | null) => {
        setLocalUser(user);
        setItem('user', JSON.stringify(user));
    };
    useEffect(() => {
        if (process.env.REACT_APP_MODE == 'Prod') {
            // Disable //console.error and //console.warn
            const originalError = console.error;
            const originalWarn = console.warn;
            const log = console.log;

            //console.error = //console.warn = //console.log = () => { };

            // Revert changes when the component unmounts
            return () => {
                //console.error = originalError;
                //console.warn = originalWarn;
                //console.log = log;
            };
        }
    }, []);
    const [showLogout, setShowLogout] = useState<any>(false);
    const [isLoading, setLoader] = useState(false);
    const [isProgress, setProgress] = useState(false);
    const [progressType, setProgressType] = useState(true);
    const [demandStatus, setDemandStatus] = useState('');

    const [randomId, setRandomId] = useState('');
    const onLogout = () => {
        setLocalUser(null);
        document.cookie = 'refreshToken=; Path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
        removeItem('user');
        navigate('/');
        setShowLogout(false);
        Notify('success', 'Logout Successfully');
    };
    const updateProgress = value => {
        setProgress(value);
    };

    return (
        <>
            <AuthContext.Provider
                value={{
                    user: userLocal,
                    setUser: addUser,
                    isLoading,
                    setLoader,
                    setShowLogout,
                    showLogout,
                    isProgress,
                    setProgress: updateProgress,
                    progressType,
                    setProgressType,
                    randomId,
                    setRandomId,
                    setDemandStatus,
                    demandStatus,
                }}
            >
                <Routes>
                    <Route
                        path="/home"
                        element={
                            <ProtectedRoute>
                                <HomeContainer />
                            </ProtectedRoute>
                        }
                    >
                        <Route path={`dashboard`} element={<Dashboard />} />
                        <Route path="location" element={<Location />} />
                        <Route path={`categories`} element={<Categories />} />
                        <Route path={`manageRoles`} element={<ManageRoles />} />
                        <Route path={`UserManagement`} element={<UserManagement />} />
                        <Route path={`items`} element={<Items />} />
                        <Route path={`penalty`} element={<Penalty />} />
                        <Route path={`others`} element={<Demand_other />} />
                        <Route path={`demands`} element={<Demand_transporter />} />
                        <Route path={`bids/:type/:id/:bread`} element={<Bids />} />
                        <Route path={`helpSupport`} element={<HelpSupport />} />
                        <Route path={`signup_request`} element={<SignupRequest />} />

                        <Route path={`mobile/Notification`} element={<Notification />} />
                        <Route path={`mobile/transporter`} element={<Transporter />} />
                        <Route path={`mobile/others`} element={<OthersMobileUsers />} />
                        <Route path={`setting`} element={<Setting />} />
                        <Route path={`finalisedbids/transporter`} element={<FinalisedBids />} />
                        <Route path={`finalisedbids/other`} element={<FinalisedBidsOthers />} />
                        <Route path={`vendordelay`} element={<VendorDelay />} />
                        <Route path={`Transporter`} element={<TransporterReport />} />
                        <Route path={`Other`} element={<OtherReport />} />
                        <Route path={`setting`} element={<Setting />} />
                        <Route path={`notification`} element={<Notification />} />
                    </Route>
                    <Route path="/" element={<LandingContainer />}></Route>

                    <Route path="/vendor_registration/:token" element={<VendoRegistration />}></Route>
                    <Route path="/vendor_registration/other/:token" element={<VendoRegistrationOther />}></Route>
                    <Route path="/forgot" element={<ForgotContainer />}></Route>
                    <Route path="/terms-and-condition" element={<TermsCondition />}></Route>
                    <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>

                    <Route path="*" element={<PageNotFound />}></Route>
                </Routes>
            </AuthContext.Provider>
            {showLogout && (
                <Modal
                    show={true}
                    onHide={() => {
                        setShowLogout(false);
                    }}
                    backdrop="static"
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Log Out</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="model">
                            <div className="text_box">
                                <h3>Are you sure you want to log out?</h3>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            className="btn dark_btn custom_btn"
                            style={{ backgroundColor: '#bb0a1e', color: 'white' }}
                            onClick={() => {
                                onLogout();
                            }}
                        >
                            Log Out
                        </Button>
                        <Button
                            variant="default"
                            className="btn custom_btn border_btn with_icon"
                            onClick={() => {
                                setShowLogout(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            <Toaster />
        </>
    );
};

export default App;
